import React, { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { PublicRoute } from '../components/PublicRoute';

// Auth Components
import SignIn from '../pages/sign-in';

// Route Components
import AdminRoutes from './adminRoutes';

type RouterProps = {}

const RootRouter: FC<RouterProps> = React.memo(() => {
  return (
    <Routes>
      {/* Default route redirect to sign-in */}
      <Route path="/" element={<Navigate to="/sign-in" replace />} />

      {/* Authentication Routes */}
      <Route path="/sign-in" element={
        <PublicRoute>
          <SignIn />
        </PublicRoute>
      } />

      {/* Alias for login -> sign-in */}
      <Route path="/login" element={<Navigate to="/sign-in" replace />} />

      {/* Admin Routes */}
      <Route path="/*" element={<AdminRoutes />} />

      {/* 404 Redirect */}
      <Route path="*" element={<Navigate to="/sign-in" replace />} />
    </Routes>
  )
});

RootRouter.displayName = "RootRouter";

export default RootRouter;
